import { makeAutoObservable, reaction } from 'mobx';

import {
  MIN_ANNUAL_AREA_AMOUNTS,
  DEFAULT_MONTHLY_AREA_AMOUNTS,
} from '../../../shared/helpers/constants/areaAmounts';
import type { IRootStore } from '../rootStore/RootStore';

export default class UiStateStore {
  rootStore: IRootStore;

  annualPlan: {
    area: string;
    additionalSeats: string;
    planetImagery: string;
  };

  monthlyPlan: {
    area: string;
    datasetImport: string;
    yieldCleaningCalibration: string;
    yieldSyntheticMapCreation: string;
    zonesMapCreation: string;
    equationMapCreation: string;
    samplingPlanCreation: string;
    exportZonesMap: string;
    additionalSeats: string;
    planetImagery: string;
  };

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;

    this.annualPlan = {
      area: MIN_ANNUAL_AREA_AMOUNTS[
        this.rootStore.areaUnitStore.areaUnit
      ].toString(),
      additionalSeats: '0',
      planetImagery: '0',
    };

    this.monthlyPlan = {
      area: DEFAULT_MONTHLY_AREA_AMOUNTS[
        this.rootStore.areaUnitStore.areaUnit
      ].toString(),
      datasetImport: '2',
      yieldCleaningCalibration: '1',
      yieldSyntheticMapCreation: '1',
      zonesMapCreation: '1',
      equationMapCreation: '1',
      samplingPlanCreation: '1',
      exportZonesMap: '1',
      additionalSeats: '0',
      planetImagery: '0',
    };

    reaction(
      () => this.rootStore.areaUnitStore.areaUnit,
      (areaUnit) => {
        this.annualPlan.area = MIN_ANNUAL_AREA_AMOUNTS[areaUnit].toString();
        this.monthlyPlan.area =
          DEFAULT_MONTHLY_AREA_AMOUNTS[areaUnit].toString();
      },
    );
  }

  setAnnualPlanArea = (area: string) => {
    this.annualPlan.area = area;
  };

  setAnnualPlanSeats = (additionalSeats: string) => {
    this.annualPlan.additionalSeats = additionalSeats;
  };

  setAnnualPlanPlanetImagery = (planetImagery: string) => {
    this.annualPlan.planetImagery = planetImagery;
  };

  setMonthlyPlanArea = (area: string) => {
    this.monthlyPlan.area = area;
  };

  setMonthlyPlanDatasetImport = (datasetImport: string) => {
    this.monthlyPlan.datasetImport = datasetImport;
  };

  setMonthlyPlanYieldCleaningCalibration = (
    yieldCleaningCalibration: string,
  ) => {
    this.monthlyPlan.yieldCleaningCalibration = yieldCleaningCalibration;
  };

  setMonthlyPlanYieldSyntheticMapCreation = (
    yieldSyntheticMapCreation: string,
  ) => {
    this.monthlyPlan.yieldSyntheticMapCreation = yieldSyntheticMapCreation;
  };

  setMonthlyPlanZonesMapCreation = (zonesMapCreation: string) => {
    this.monthlyPlan.zonesMapCreation = zonesMapCreation;
  };

  setMonthlyPlanEquationMapCreation = (equationMapsCreation: string) => {
    this.monthlyPlan.equationMapCreation = equationMapsCreation;
  };

  setMonthlyPlanSamplingPlanCreation = (samplingPlanCreation: string) => {
    this.monthlyPlan.samplingPlanCreation = samplingPlanCreation;
  };

  setMonthlyPlanExportZonesMap = (exportZonesMap: string) => {
    this.monthlyPlan.exportZonesMap = exportZonesMap;
  };

  setMonthlyPlanSeats = (additionalSeats: string) => {
    this.monthlyPlan.additionalSeats = additionalSeats;
  };

  setMonthlyPlanPlanetImagery = (planetImagery: string) => {
    this.monthlyPlan.planetImagery = planetImagery;
  };
}
